firebird.controller('electronScreenModalCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'logService',
    'helperService',
    'supportLinkService',
    'macSecurityPreferencesService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        logService,
        helperService,
        supportLinkService,
        macSecurityPreferencesService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'electronScreenModalCtrl');

        self.modalState = 'closed';

        self.sources = [];
        self.appSources = [];
        self.share = share;
        self.openSystemPreference = openSystemPreference;
        self.clickSource = clickSource;
        self.doubleClickSource = doubleClickSource;
        self.previewScreenSelected = previewScreenSelected;
        self.previewScreenClear = previewScreenClear;

        self.possibleCatalinaError = false;
        self.showCatalinaError = false;
        self.isCatalina = false;
        self.catalinaHelpLink = supportLinkService.getSupportLink('catalinaScreenShare');
        self.isSettingsOpening = false;
        self.cancelSettingsOpeningTimeout = cancelSettingsOpeningTimeout;

        self.getUniqueSourceThumbId = getUniqueSourceThumbId;
        self.selectedSource = null;

        self.isScreenSource = isScreenSource;
        self.isOtherAppWindow = isOtherAppWindow;
        self.VDIRef = helperService.getVDIRef();
        self.screenShareSelected = false;

        self._onShowModal = onShowModal;
        self._onHideModal = onHideModal;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        ////////////////////////

        init();

        function init() {
            $window.$('#screen-tab').tab('show');
            self.possibleCatalinaError = self.isCatalina = isElectronCatalina();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'electronScreen') {
                return loadSources().then(() => {
                    self.modalState = 'open';
                    self.screenShareSelected = false;
                    digest();
                });
            }

            return Promise.resolve();
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('electronScreen') !== -1) {
                self.cancelSettingsOpeningTimeout();

                self.modalState = 'closed';
                $rootScope.$broadcast('electron-screen-preview-destroy');
                if (e) {
                    if (!self.screenShareSelected) {
                        $rootScope.$broadcast('screen-share-init-cancel');
                    }
                    self.screenShareSelected = false;
                }
                digest();
            }
        }

        function getUniqueSourceThumbId(id) {
            return 'preview' + id.replace(/\W/gi, '');
        }

        function share() {
            if (self.selectedSource !== null) {
                $rootScope.$broadcast('electron-screen-selected', {
                    name: self.selectedSource.name,
                    id: self.selectedSource.id,
                    displayId: self.selectedSource.displayId
                });
                self.screenShareSelected = true;
                close();
            }
        }

        function openSystemPreference() {
            self.cancelSettingsOpeningTimeout();
            self.isSettingsOpening = true;

            self.settingsOpeningTimeout = $timeout(function () {
                close();
                self.isSettingsOpening = false;
            }, 10000);

            macSecurityPreferencesService.openScreenCapture();
        }

        function cancelSettingsOpeningTimeout() {
            if (self.settingsOpeningTimeout) {
                $timeout.cancel(self.settingsOpeningTimeout);
                self.settingsOpeningTimeout = null;
                self.isSettingsOpening = false;
            }
        }

        function clickSource(source) {
            if (helperService.getIsRedesign() === true) {
                var oldId = self.selectedSource !== null ? self.getUniqueSourceThumbId(self.selectedSource.id) : null;
                var newId = self.getUniqueSourceThumbId(source.id);
                self.selectedSource = source;

                //Empty timeout added in order for the element classes to get modified at the end of a digest cycle
                //(ensures the elements are on the page before modifying)
                $timeout(function () {
                    if (oldId !== null) {
                        $window.$('#' + oldId).removeClass('selected');
                    }
                    $window.$('#' + newId).addClass('selected');
                });
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-selected', {
                    name: source.name,
                    id: source.id,
                    displayId: source.displayId
                });
                close();
            }
        }

        function doubleClickSource(source) {
            $rootScope.$broadcast('electron-screen-selected', {
                name: source.name,
                id: source.id,
                displayId: source.displayId
            });
            close();
        }

        function previewScreenSelected(source) {
            if (helperService.getIsRedesign() === true) {
                if (source.id.indexOf('screen:') === 0) {
                    $rootScope.$broadcast('electron-screen-preview', {
                        name: source.name,
                        id: source.id,
                        displayId: source.displayId
                    });
                }
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-preview', {
                    name: source.name,
                    id: source.id,
                    displayId: source.displayId
                });
            }
        }

        function previewScreenClear(source) {
            if (helperService.getIsRedesign() === true) {
                if (source.id.indexOf('screen:') === 0) {
                    $rootScope.$broadcast('electron-screen-preview-clear');
                }
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-preview-clear');
            }
        }

        function loadSources() {
            return new Promise(resolve => {
                if (!$window.preloadedApi.desktopCapturer.isAvailable()) {
                    logger.error('loadSources', 'electron Screen selection called but desktopCapturer not available');
                    resolve();
                    return;
                }
                self.appSources = [];
                self.sources = [];

                //we're leaving the sources looping code in below for future implementation, but by changing the sources
                // types from ['window','screen'] to just ['screen'] we're effectively turning off app sharing for
                // electron
                var getSourcesCallback = function (sources) {
                    return Promise.resolve(sources)
                        .then(sources => {
                            logger.log('sources passed to getSourcesCallback', sources);

                            for (var i = 0; i < sources.length; i++) {
                                if (self.isCatalina && self.possibleCatalinaError) {
                                    //check this window to see if we can exclude the error
                                    checkForOtherAppWindow(sources[i]);
                                }

                                if (
                                    sources[i].name.toLowerCase() === 'search pane' ||
                                    sources[i].name.toLowerCase() === 'start menu' ||
                                    sources[i].name.toLowerCase() === 'search' ||
                                    sources[i].name.toLowerCase() === 'immersive background' ||
                                    sources[i].name.toLowerCase() === 'snapped desktop'
                                ) {
                                    continue;
                                }

                                const tempSource = {
                                    name: sources[i].name,
                                    id: sources[i].id,
                                    displayId: sources[i].display_id,
                                    dataURL: sources[i].thumbnail.toDataURL(),
                                    iconURL: sources[i].appIcon?.toDataURL()
                                };
                                if (tempSource.id.indexOf('screen:') === 0) {
                                    logger.log(
                                        'loadSources',
                                        'screen: adding screenshare source to list of sources: ',
                                        tempSource
                                    );
                                    self.sources.push(tempSource);
                                } else {
                                    logger.log('loadSources', 'app: before name fix: ', tempSource);
                                    tempSource.name = fixName(tempSource.name);
                                    logger.log(
                                        'loadSources',
                                        'app: adding screenshare source to list of sources: ',
                                        tempSource
                                    );
                                    self.appSources.push(tempSource);
                                }
                            }

                            if (helperService.getIsRedesign() === true && self.sources[0]) {
                                self.clickSource(self.sources[0]);
                            }
                        })
                        .then(() => {
                            return helperService.getElectronVersion() < 7
                                ? self.possibleCatalinaError
                                : !helperService.hasScreenRecordingPermissions();
                        })
                        .then(showError => {
                            self.showCatalinaError = showError;
                            logger.log(
                                'loadSources',
                                'Final state of catalina check: isCatalina :' +
                                    self.isCatalina +
                                    ' possibleCatalinaError:' +
                                    self.possibleCatalinaError
                            );
                        })
                        .then(digest())
                        .catch(error => {
                            logger.error('loadSources', 'Error in getSourcesCallback', error);
                        });
                };

                let getSourcesOptions = getSourceOptions();
                $window.preloadedApi.desktopCapturer
                    .getSources(getSourcesOptions)
                    .then(sources => resolve(getSourcesCallback(sources)));
            });
        }

        function getSourceOptions() {
            let types;
            if (!self.VDIRef.shareApplicationScreen) {
                types = ['screen'];
            } else {
                types = ['screen', 'window'];
            }

            let getSourcesOptions;
            if (helperService.getIsRedesign() === true) {
                getSourcesOptions = { types: types, fetchWindowIcons: true };
            } else {
                //TODO: REMOVE POST-REDESIGN
                getSourcesOptions = { types: types };
            }

            return getSourcesOptions;
        }

        function close() {
            onHideModal(null, 'electronScreen');
        }

        function isElectronCatalina() {
            if (!helperService.isElectronOnMac()) {
                logger.log('isElectronCatalina', 'No electron detected in isElectronCatalina');
                return false;
            }

            try {
                var systemInfo = helperService.getSystemInfo();
                var releaseString = systemInfo.osRelease;
                var parts = releaseString.split('.');

                if (parts[0] === '19') {
                    logger.log('isElectronCatalina', 'Found Catalina');
                    return true;
                }
            } catch (err) {
                logger.error('isElectronCatalina', 'Error', err);
            }

            return false;
        }

        function isScreenSource(source) {
            if (!source || !source.id) {
                return false;
            }

            if (source.id.split(':')[0] === 'screen') {
                return true;
            }

            return false;
        }

        function checkForOtherAppWindow(source) {
            if (isOtherAppWindow(source)) {
                self.possibleCatalinaError = false;
            }
        }

        function isOtherAppWindow(source) {
            if (!source || !source.id || !source.name) {
                return false;
            }

            if (source.id.split(':')[0] === 'screen') {
                return false;
            }

            if (
                source.name.toLowerCase().indexOf('developer tools') === 0 ||
                source.name.toLowerCase().indexOf('anymeeting') === 0 ||
                source.name.toLowerCase().indexOf('intermedia unite') === 0 ||
                source.name.toLowerCase().indexOf('elevate uc') === 0 ||
                source.name.toLowerCase().indexOf('| anymeeting') > 0 ||
                source.name.toLowerCase().indexOf('| online meeting') > 0
            ) {
                return false;
            }

            logger.log('isOtherAppWindow', 'Found excluding application window in catalina');
            return true;
        }

        function fixName(name) {
            var maxLength;
            if (helperService.getIsRedesign() === true) {
                maxLength = 23;
            } else {
                //TODO: REMOVE POST-REDESIGN
                maxLength = 22;
            }

            if (!name || name.length <= maxLength) {
                return name;
            }

            return name.substring(0, maxLength - 3) + '...';
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
